import { render, staticRenderFns } from "./OverviewTableSurveyDataManagement.vue?vue&type=template&id=3b2933b4&"
import script from "./OverviewTableSurveyDataManagement.vue?vue&type=script&lang=ts&"
export * from "./OverviewTableSurveyDataManagement.vue?vue&type=script&lang=ts&"
import style0 from "./OverviewTableSurveyDataManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VProgressCircular,VRow})
